/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Verified_ButtonInputs */



/**
* | output |
* | --- |
* | "I've Verified My Email" |
*
* @param {Login_Verified_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_verified_button = /** @type {((inputs?: Login_Verified_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Verified_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("J'ai Vérifié Mon Email")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich habe meine E-Mail-Adresse bestätigt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ho verificato la mia email")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Я подтвердил свой адрес электронной почты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("He verificado mi correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("我已经验证了我的邮箱")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールを確認しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैंने अपना ईमेल सत्यापित कर लिया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifiquei meu e-mail.")
	return /** @type {LocalizedString} */ ("I've Verified My Email")
});